module.exports = __webpack_public_path__ + "static/media/testing-eirich-1-s.46e026e8.webp";